import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllInvoicesComponent } from './components/all-invoices/all-invoices.component';
import { InvoiceDetailsComponent } from './components/invoice-details/invoice-details.component';
import { InvoiceEditComponent } from './components/invoice-edit/invoice-edit.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'all-invoices',
    pathMatch: 'full'
  },

  {
    path: 'all-invoices',
    component: AllInvoicesComponent,
    data: {
      title: 'Invoices'
    }
  },
  {
    path: 'edit-invoice/:transactionId',
    component: InvoiceEditComponent,
    data: {
      title: 'Edit Invoice'
    }
  },
  {
    path: 'duplicate-invoice/:transactionId',
    component: InvoiceEditComponent,
    data: {
      title: 'Duplicate Invoice'
    }
  },
  {
    path: 'create-invoice',
    component: InvoiceEditComponent,
    data: {
      title: 'Create Invoice'
    }
  },
  {
    path: 'invoice-details/:invoiceId',
    component: InvoiceDetailsComponent,
    data: {
      title: 'Invoice'
    }
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InvoiceRoutingModule {}
